import React from 'react'
import { DownloadsCategoryModel, DownloadsFilter } from '../models/downloads.model'
import DownloadsList from './DownloadsList'
import { Paper, Stack, useMediaQuery, useTheme } from '@mui/material'
import UserLevelTag from './UserLevelTag'
import ServiceActions from './ServiceActions'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import CategoryBreadcrumbs from './CategoryBreadcrumbs'
import { useCategoryDisplayName } from '../hooks'

interface Props {
  category: DownloadsCategoryModel
  filters: DownloadsFilter
  isServiceUser?: boolean
  favoriteFileIds: number[]
  selectCategory: (categoryId?: number) => void
}

/**
 * View of second level category with it's content that acts as a seperate view inside the downloads list
 */
const CategoryDetails: React.FC<Props> = ({ category, isServiceUser, filters, favoriteFileIds, selectCategory }) => {
  const getCategoryDisplayName = useCategoryDisplayName()
  const directParent = category?.parents?.at(-2)
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.only('xs'))

  const breadcrumbs = [
    ...category.parents.map(parent => ({ id: parent.id, name: getCategoryDisplayName(parent.nameLanguages) })),
    { id: category.id, name: getCategoryDisplayName(category.nameLanguages) },
  ]

  return (
    <Paper sx={{ padding: 4 }}>
      <CategoryBreadcrumbs parentCategories={breadcrumbs} onClickCategory={selectCategory} />
      <Stack direction={'column'} justifyContent={'space-between'} alignItems={'flex-start'}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent={{ xs: 'space-between', sm: 'flex-end' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          mb={2}
          width="100%"
        >
          {getCategoryDisplayName(category.nameLanguages) && isXs && (
            <Typography variant={'h2'} order={0} fontWeight={'bold'}>
              {getCategoryDisplayName(category.nameLanguages)}
            </Typography>
          )}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 9 }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent={{ xs: 'space-between', sm: 'flex-start' }}
            mb={{ xs: 2 }}
            order={{ xs: 2, sm: 1 }}
            width="100%"
          >
            {isServiceUser && <UserLevelTag isVisibleUser={category.visibleToCustomer} isVisibleInstallerPartner={category.visibleToInstaller} />}
          </Stack>
          {isServiceUser && <ServiceActions parent={directParent} item={category} selectCategory={selectCategory} sx={{ order: { xs: 1, sm: 2 } }} />}
        </Stack>
      </Stack>

      <DownloadsList
        favoriteFileIds={favoriteFileIds}
        category={category}
        isServiceUser={isServiceUser}
        filters={filters}
        setChosenCategoryId={selectCategory}
      />
    </Paper>
  )
}

export default CategoryDetails
